import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ButtonPrimary,
  ModalContent,
  ModalHeader,
  Loader,
  SelectInputSearch,
  Checkbox,
  Input,
  DataTable,
  IconTrash,
} from '@skf/bt-wind-rail-commonlibrary';
import {
  ITurbineManagementAssetsProps,
  ModifyAsset,
  TaxonomyAddAssetInfo,
  TaxonomyAssetInfoAdmin,
  TaxonomyAssetManufacturer,
  TaxonomyBearingInfoAdmin,
  TaxonomyCustomerAdmin,
  TaxonomySystemInfoAdminCompleted,
} from '../../../../store/taxonomy/types';
import { FullscreenModal } from '../../../common/fullscreenModal/FullscreenModal';
import style from './TurbineManagementFormulary.module.scss';
import { IOption } from '@skf/bt-wind-rail-commonlibrary/dist/components/form/types';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAssetsManufacturerModels,
  PostAddNewAsset,
  PostModifyAsset,
} from '../../../../store/taxonomy/actions';
import { StoreState } from '../../../../store/store';
import { ITaxonomyState } from '../../../../store/taxonomy/store';
import { assetTypeAcronymOptions } from '../utils/constants';
import { fetchAssets } from '../../../../api/assets';
import { useToast } from '../../../../hooks/useToast';

export const TurbineManagementFormularyAssets: React.FunctionComponent<ITurbineManagementAssetsProps> = ({
  taxonomy,
  turbines,
  windfarms,
  assets,
  turbineSelected,
  onClose,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { addToast } = useToast();

  const [isFetching, setIsFetching] = useState<boolean>(false);
  const borderOk = { border: `1px solid #c7cad0` };
  const borderError = {
    border: `1px solid red`,
    borderColor: `red !important`,
  };

  const [_windfarmsOptions, _setWindfarmsOptions] = useState<IOption[]>([]);
  const [_windfarmValue, _setWindfarmValue] = useState<string>('');
  const [_windfarmValidation, _setWindfarmValidation] = useState<boolean>(
    false
  );
  const [_windfarmDisabled, _setWindfarmDisabled] = useState<boolean>(false);
  const [_turbineOptions, _setTurbineOptions] = useState<IOption[]>([]);
  const [_turbineValue, _setTurbineValue] = useState<string>('');
  const [_turbineValidation, _setTurbineValidation] = useState<boolean>(false);
  const [_turbineDisabled, _setTurbineDisabled] = useState<boolean>(false);
  //   const [
  //     _assetClassDescriptionOptions,
  //     _setAssetClassDescriptionOptions,
  //   ] = useState<IOption[]>([]);
  //   const [
  //     _assetClassDescriptionValue,
  //     _setAssetClassDescriptionValue,
  //   ] = useState<string>('');
  const [
    _assetClassDescriptionValidation,
    _setAssetClassDescriptionValidation,
  ] = useState<boolean>(false);
  const [_manufacturerModelOptions, _setManufacturerModelOptions] = useState<
    IOption[]
  >([]);
  const [_manufacturerModelValue, _setManufacturerModelValue] = useState<
    string
  >('');
  const [
    _manufacturerModelValidation,
    _setManufacturerModelValidation,
  ] = useState<boolean>(false);

  const [_autoSIDbool, _setAutoSIDbool] = useState<boolean>(true);
  const [_sidValue, _setSidValue] = useState<string>('');
  const [_sidValidation, _setSidValidation] = useState(borderOk);
  const [newModel, setNewModel] = useState<boolean>(false);
  const [_modelBoolValidation, _setModelBoolValidation] = useState(borderOk);
  const [showManufacturerModelInput, setShowManufacturerModelInput] = useState<
    boolean
  >(false);
  const [_manufacturerName, _setManufacturerName] = useState<string>('');
  const [_manufacturerSerialNumber, _setManufacturerSerialNumber] = useState<
    string
  >('');
  const [
    _manufacturerSerialNumberValidation,
    _setManufacturerSerialNumberValidation,
  ] = useState(borderOk);
  const [_costOfReplacement, _setCostOfReplacement] = useState<string | null>();
  const [
    _costOfReplacementValidation,
    _setCostOfReplacementValidation,
  ] = useState(borderOk);
  const [_purchaseCondition, _setPurchaseCondition] = useState<string>('');
  const [
    _purchaseConditionValidation,
    _setPurchaseConditionValidation,
  ] = useState(borderOk);
  const [_equipAttributesEffile, _setEquipAttributesEffile] = useState<string>(
    ''
  );
  const [instaledDateValidation, _setInstaledDateValidation] = useState(
    borderOk
  );
  const [
    _equipAttributesEffileValidation,
    _setEquipAttributesEffileValidation,
  ] = useState(borderOk);
  const [_intaledDate, _setInstaledDate] = useState<Date | string>();
  const [_assetTypeAcronym, _setAssetTypeAcronym] = useState<string>('');
  const [_assetsDataList, _setAssetsDataList] = useState<
    TaxonomyAddAssetInfo[]
  >([]);
  const [_bearingsList, _setBearingsList] = useState<
    TaxonomyBearingInfoAdmin[]
  >([]);
  const { taxonomyAssetManufacturer } = useSelector<StoreState, ITaxonomyState>(
    (selector) => selector.taxonomyAssetManufacturer
  );
  const [
    assetClassDescriptionOptions,
    setAssetClassDescriptionOptions,
  ] = useState<IOption[]>([]);
  const [editing, setEditing] = useState<boolean>(false);
  const [manufacturerNameOptions, setManufacturerNameOptions] = useState<
    IOption[]
  >([]);
  //  const [
  //   assetClassDescriptionOptions,
  //   setAssetClassDescriptionOptions,
  // ] = useState<IOption[]>([]);

  useEffect(() => {
    getAllWindFarms();
    getAllTurbines();

    if (assets && assets.assetClaseCode) {
      dispatch(getAssetsManufacturerModels(assets.assetClaseCode));
    }

    if (taxonomy) {
      setAssetClassDescriptionOptions(assetTypeAcronymOptions);
      setEditing(true);
    }
  }, []);

  useEffect(() => {
    if (newModel) {
      _setManufacturerName('');
    }
  }, [newModel]);

  useEffect(() => {
    if (taxonomy && turbines && windfarms && assets) {
      const windfarmSelected = windfarms.find(
        (x) => x.plantUnitKey === taxonomy.plantUnitKey
      );
      const turbineSelected = turbines.find(
        (x) => x.sectionSystemId === taxonomy.sectionSystemId
      );

      if (_windfarmsOptions.length > 0 && _turbineOptions.length > 0) {
        const wOption = _windfarmsOptions.find(
          (x) => x.value === windfarmSelected?.plantUnitKey
        );

        _setWindfarmValue(wOption ? wOption.value.toString() : '');
        _setWindfarmDisabled(true);

        const tOption = _turbineOptions.find(
          (x) => x.value === turbineSelected?.sectionSystemId
        );
        _setTurbineValue(tOption ? tOption.value.toString() : '');
        _setTurbineDisabled(true);
        _setSidValue(assets.assetKey);
        _setManufacturerSerialNumber(
          assets.manufacturerSerialNumber ? assets.manufacturerSerialNumber : ''
        );
        _setCostOfReplacement(assets.costReplacement || null);
        _setPurchaseCondition(
          assets.purchaseCondition ? assets.purchaseCondition : ''
        );
        _setEquipAttributesEffile(
          assets.equioAttributes ? assets.equioAttributes : ''
        );

        if (assets.assetInstalledDate) {
          const d = new Date(assets.assetInstalledDate);
          const year = d.getFullYear();
          let month = d.getMonth().toString();
          if (Number(month) < 10) month = '0' + month;
          let day = d.getDate().toString();
          if (Number(day) < 10) day = '0' + day;
          _setInstaledDate(year + '-' + month + '-' + day);
        }
      }
      if (assets.taxonomiesPart && assets.taxonomiesPart.length > 0) {
        _setBearingsList(assets.taxonomiesPart);
      }
    }
  }, [_windfarmsOptions, _turbineOptions]);

  useEffect(() => {
    if (taxonomyAssetManufacturer && assets) {
      const typeAcronym = assetTypeAcronymOptions.find(
        (x) => x.value === assets.assetClaseCode
      );

      if (typeAcronym) {
        _setAssetTypeAcronym(typeAcronym.value.toString());
        const manufacturer = taxonomyAssetManufacturer.find(
          (currentTaxonomyAssetManufacturer: TaxonomyAssetManufacturer) =>
            currentTaxonomyAssetManufacturer.manufacturerModel ===
            assets.manufacturerModel
        );

        if (!manufacturer) {
          setShowManufacturerModelInput(true);
        }

        _setManufacturerModelValue(
          manufacturer
            ? manufacturer.manufacturerModel
            : assets.manufacturerModel
        );

        const manufacturerNameOptions =
          handleManufacturerModelToName(assets.manufacturerModel) || [];

        setManufacturerNameOptions(manufacturerNameOptions);
        _setManufacturerName(assets.manufacturerName);
      }
    }

    // _setAssetClassDescriptionOptions
    // rellenar el ManufacturerModelOptions
    let manufacturerModelOptions: IOption[] = [];
    if (taxonomyAssetManufacturer && taxonomyAssetManufacturer.length > 0) {
      _setManufacturerModelOptions([]);
      taxonomyAssetManufacturer.forEach((currentTaxonomyAssetManufacturer) => {
        if (
          !manufacturerModelOptions.find(
            (currentManufacturerModelOption: IOption) =>
              currentManufacturerModelOption.value ===
              currentTaxonomyAssetManufacturer.manufacturerModel
          )
        )
          manufacturerModelOptions.push({
            label: currentTaxonomyAssetManufacturer.manufacturerModel,
            value: currentTaxonomyAssetManufacturer.manufacturerModel,
            labelToShow: currentTaxonomyAssetManufacturer.manufacturerModel,
          });
      });

      _setManufacturerModelOptions(manufacturerModelOptions);
    }
  }, [taxonomyAssetManufacturer, assets]);

  useEffect(() => {
    if (_assetsDataList.length <= 0) {
      _setWindfarmDisabled(false);
      _setTurbineDisabled(false);
    } else {
      _setWindfarmDisabled(true);
      _setTurbineDisabled(true);
    }
  }, [_assetsDataList]);

  useEffect(() => {
    // AUTO ID LOGIC
    if (_autoSIDbool) {
      if (turbines && _assetTypeAcronym && _turbineValue) {
        const selectedTurbine = turbines.find(
          (x) => x.sectionSystemId === _turbineValue
        );
        if (selectedTurbine) {
          _setSidValue(
            `${selectedTurbine?.sectionSystemId}.${_assetTypeAcronym}`
          );
        } else {
          _setSidValue(`${_turbineValue}.${_assetTypeAcronym}`);
        }
      }
    } else {
      _setSidValue('');
    }
  }, [_autoSIDbool, _assetTypeAcronym, _turbineValue, turbines]);

  function getAllTurbines() {
    if (!turbines) return;

    const filtertTurbines: IOption[] = [];
    turbines.forEach((turbine: TaxonomySystemInfoAdminCompleted) => {
      if (
        turbine.systemBrand &&
        !filtertTurbines.find(
          (filteredTurbine: IOption) =>
            filteredTurbine.value === turbine.sectionSystemId
        )
      ) {
        filtertTurbines.push({
          label: turbine.sectionSystemId,
          value: turbine.sectionSystemId,
          labelToShow: turbine.sectionSystemId,
        });
      }

      _setTurbineOptions(filtertTurbines);
    });
  }

  function getAllWindFarms() {
    if (!windfarms) return;

    const filteredWindfarms: IOption[] = [];
    windfarms.forEach((windfarm: TaxonomyCustomerAdmin) => {
      if (
        !filteredWindfarms.find(
          (filteredWindfarm: IOption) =>
            filteredWindfarm.value === windfarm.plantUnitKey
        )
      ) {
        if (windfarm?.plantUnitDescription)
          filteredWindfarms.push({
            label: windfarm?.plantUnitDescription,
            value: windfarm.plantUnitKey,
            labelToShow: windfarm?.plantUnitDescription,
          });
      }
    });

    _setWindfarmsOptions(filteredWindfarms);
  }

  const handleSelectWindfarm = (e: IOption | undefined) => {
    if (e === null) {
      _setWindfarmValue('');
      _setTurbineValue('');
      getAllTurbines();
      return;
    }

    if (e?.value) {
      const filteredTurbinesOptions: IOption[] = [];
      const filteredTurbines:
        | TaxonomySystemInfoAdminCompleted[]
        | undefined = turbines?.filter(
        (turbine) => turbine.plantUnitKey === e.value
      );

      filteredTurbines?.forEach(
        (filteredTurbine: TaxonomySystemInfoAdminCompleted) => {
          if (
            filteredTurbine.systemBrand &&
            !filteredTurbinesOptions.find(
              (e2: IOption) => e2.value === filteredTurbine.sectionSystemId
            )
          ) {
            filteredTurbinesOptions.push({
              label: filteredTurbine.sectionSystemId,
              value: filteredTurbine.sectionSystemId,
              labelToShow: filteredTurbine.sectionSystemId,
            });
          }
        }
      );

      _setTurbineOptions(filteredTurbinesOptions);
      _setTurbineValue('');
      _setWindfarmValue(e.value.toString());
    }
  };

  const handleSelectTurbine = async (e: IOption | undefined) => {
    if (e && e.value) {
      if (!taxonomy) {
        const turbineSelected = turbines?.find(
          (turbine) => turbine.sectionSystemId === e.value
        );
        const windfarmOfTurbine = windfarms?.find(
          (windfarm) => windfarm.plantUnitKey === turbineSelected?.plantUnitKey
        );
        _setWindfarmValue(windfarmOfTurbine?.plantUnitKey || '');

        setIsFetching(true);
        const assets: TaxonomyAssetInfoAdmin[] = await fetchAssets(
          turbineSelected?.plantUnitKey,
          turbineSelected?.sectionSystemKey
        );
        const assetClassCodes: string[] = assets.map(
          (asset) => asset.assetClaseCode
        );

        const assetClassDescriptionFiltered = assetTypeAcronymOptions.filter(
          (o1) => !assetClassCodes.some((o2) => o1.value === o2)
        );

        if (assetClassDescriptionFiltered.length <= 0) {
          addToast({
            status: 'warning',
            message: t('all_assets_on_turbine'),
            timeout: 10000,
          });
        }

        _setAssetTypeAcronym('');
        setAssetClassDescriptionOptions(assetClassDescriptionFiltered);
        setIsFetching(false);
      }

      _setTurbineValue(e.value.toString());
    } else {
      getAllTurbines();
    }
  };

  const handleManufacturerModelToName = (manufacturerModel: string) => {
    if (taxonomyAssetManufacturer && taxonomyAssetManufacturer.length > 0) {
      const nameList = taxonomyAssetManufacturer.find(
        (x) => x.manufacturerModel === manufacturerModel
      );
      const manufacturerNameOpt = nameList?.manufacturerName.map(
        (manufacturerName) => ({
          label: manufacturerName,
          value: manufacturerName,
          labelToShow: manufacturerName,
        })
      );

      setManufacturerNameOptions(manufacturerNameOpt || []);

      return manufacturerNameOpt;
    }

    return [];
  };

  const columnsAsset: any[] = [
    {
      Header: t('SID'),
      accessor: 'assetId',
    },
    {
      Header: t('WindFarm'),
      accessor: 'windFarmId',
    },
    {
      Header: t('Turbine'),
      accessor: 'turbineId',
    },
    {
      Header: t('Manufacturer'),
      accessor: 'manufacturerName',
    },
    {
      Header: '',
      accessor: 'Action',
      disableSortBy: true,

      Cell: ({
        row: {
          original: { assetId },
        },
      }: any) => {
        return (
          <div>
            <IconTrash
              onClick={() => RemoveAssetFromList(assetId)}
              className={style.cursorPointer}
            />
          </div>
        );
      },
    },
  ];

  const columnsBearings: any[] = [
    {
      Header: t('assetID'),
      accessor: 'assetId',
    },
    {
      Header: t('position'),
      accessor: 'position',
    },
    {
      Header: t('skfPartCode'),
      accessor: 'skfPartCode',
    },
  ];

  const RemoveAssetFromList = (SID: string) => {
    _setAssetsDataList(
      _assetsDataList.filter((x) => x.assetId.toString() !== SID)
    );
  };

  const ValidateForm = () => {
    let toReturn: boolean = true;

    if (!_windfarmValue) {
      _setWindfarmValidation(true);
      toReturn = false;
    } else {
      _setWindfarmValidation(false);
    }
    if (!_turbineValue) {
      _setTurbineValidation(true);
      toReturn = false;
    } else {
      _setTurbineValidation(false);
    }
    if (!_assetTypeAcronym) {
      _setAssetClassDescriptionValidation(true);
      toReturn = false;
    } else {
      _setAssetClassDescriptionValidation(false);
    }
    if (!_manufacturerModelValue) {
      _setManufacturerModelValidation(true);
      toReturn = false;
    } else {
      _setManufacturerModelValidation(false);
    }

    if (!_sidValue) {
      _setSidValidation(borderError);
      toReturn = false;
    } else {
      _setSidValidation(borderOk);
    }

    if (!_intaledDate) {
      _setInstaledDateValidation(borderError);
      toReturn = false;
    } else {
      _setInstaledDateValidation(borderOk);
    }

    // if(!_manufacturerName){
    //     _setManufacturerNameValidation(borderError);
    //     toReturn = false
    // }else{
    //     _setManufacturerNameValidation(borderOk);
    // }
    // if(!_manufacturerSerialNumber){
    //     _setManufacturerSerialNumberValidation(borderError);
    //     toReturn = false
    // }else{
    //     _setManufacturerSerialNumberValidation(borderOk);
    // }
    // if(!_costOfReplacement){
    //     _setCostOfReplacementValidation(borderError);
    //     toReturn = false
    // }else{
    //     _setCostOfReplacementValidation(borderOk);
    // }
    // if(!_purchaseCondition){
    //     _setPurchaseConditionValidation(borderError);
    //     toReturn = false
    // }else{
    //     _setPurchaseConditionValidation(borderOk);
    // }
    // if(!_equipAttributesEffile){
    //     _setEquipAttributesEffileValidation(borderError);
    //     toReturn = false
    // }else{
    //     _setEquipAttributesEffileValidation(borderOk);
    // }

    if (_assetsDataList && _assetsDataList.length > 0) {
      const exists = _assetsDataList.filter(
        (x) => x.assetId.toString() === _sidValue
      );
      if (exists && exists.length > 0) {
        _setAssetClassDescriptionValidation(true);
        toReturn = false;
      }
    }

    return toReturn;
  };

  const AddAssetToList = () => {
    if (ValidateForm()) {
      if (windfarms && turbines) {
        const assetToAdd: TaxonomyAddAssetInfo = {
          windFarmId:
            windfarms.find(
              (x) =>
                x.plantUnitKey ===
                  turbines
                    .find((x) => x.sectionSystemId === _turbineValue)
                    ?.plantUnitKey?.toString() || ''
            )?.plantUnitId || '',
          turbineId:
            turbines
              .find((x) => x.sectionSystemId === _turbineValue)
              ?.sectionSystemId?.toString() || '',
          assetId: _sidValue,
          assetClassCode: _assetTypeAcronym,
          manufacturerModel: _manufacturerModelValue,
          manufacturerName: _manufacturerName,
          manufacturerSerialNumber: _manufacturerSerialNumber,
          costReplacement: _costOfReplacement ? _costOfReplacement : null,
          purchaseCondition: _purchaseCondition,
          equipAttributes: _equipAttributesEffile,
          assetInstalledDate: _intaledDate ? _intaledDate : undefined,
          isNew: newModel,
          sectionSystemKey:
            turbines
              .find((x) => x.sectionSystemId === _turbineValue)
              ?.sectionSystemKey?.toString() || '',
          plantUnitKey:
            windfarms.find(
              (x) =>
                x.plantUnitKey ===
                  turbines
                    .find((x) => x.sectionSystemId === _turbineValue)
                    ?.plantUnitKey?.toString() || ''
            )?.plantUnitKey || '',
        };

        _setAssetsDataList([..._assetsDataList, assetToAdd]);
      }
    }
  };

  const sendData = () => {
    const addAssetOk = () => {
      addToast({
        status: 'ok',
        message: t('addAssetOk'),
        timeout: 7000,
      });
    };
    const addAssetProgress = () => {
      addToast({
        status: 'warning',
        message: t('addAsset'),
        timeout: 7000,
      });
    };
    const addAssetFailed = () => {
      addToast({
        status: 'danger',
        message: t('failedAddAsset'),
        timeout: 7000,
      });
    };
    dispatch(
      PostAddNewAsset(
        _assetsDataList,
        addAssetOk,
        addAssetProgress,
        addAssetFailed,
        turbineSelected
      )
    );
    onClose();
  };

  const sendDataModify = () => {
    if (assets) {
      let year: number = 0;
      let month: number = 0;
      let day: number = 0;
      if (_intaledDate) {
        const d = new Date(_intaledDate);
        year = d.getFullYear();
        month = d.getMonth();
        day = d.getDate();
      }
      const modifyObject: ModifyAsset = {
        assetKey: assets.assetKey,
        windFarmId: assets.plantUnitKey,
        turbineId: assets.sectionSystemId,
        sectionSystemKey: assets.sectionSystemKey,
        assetId: assets.assetId,
        assetClassCode: assets.assetClaseCode,
        manufacturerModel: _manufacturerModelValue,
        manufacturerName: _manufacturerName,
        manufacturerSerialNumber: _manufacturerSerialNumber,
        costReplacement: _costOfReplacement ? _costOfReplacement : null,
        purchaseCondition: _purchaseCondition,
        equipAttributes: _equipAttributesEffile,
        assetInstalledDate: new Date(year, month, day),
        IsChangeModel: assets.manufacturerModel !== _manufacturerModelValue,
        IsNew: newModel,
        IsModify: true,
        plantUnitKey: assets.plantUnitKey,
      };
      const toastrAssetId = modifyObject.assetId || '';
      const modifyAssetOk = () => {
        addToast({
          status: 'ok',
          message: t('modifyAssetOk'),
          timeout: 7000,
        });
      };
      const modifyAssetProgress = () => {
        addToast({
          status: 'warning',
          message: t('modifyAsset').replace('@', toastrAssetId),
          timeout: 7000,
        });
      };
      const modifyAssetFailed = () => {
        addToast({
          status: 'danger',
          message: t('failedUpdateAsset').replace('@', toastrAssetId),
          timeout: 7000,
        });
      };

      dispatch(
        PostModifyAsset(
          modifyObject,
          modifyAssetOk,
          modifyAssetProgress,
          modifyAssetFailed
        )
      );
    }
    onClose();
  };

  const handleSelectAssetClassDescription = (value: string) => {
    _setAssetTypeAcronym(value);
    _setAssetClassDescriptionValidation(false);
    _setManufacturerModelOptions([]);
    _setManufacturerModelValue('');
    _setManufacturerName('');
    setManufacturerNameOptions([]);

    if (value !== '') {
      dispatch(getAssetsManufacturerModels(value));
    }
  };

  const disableSaveButton =
    !taxonomy &&
    (assetClassDescriptionOptions.length <= 0 || _assetsDataList.length <= 0);

  return (
    <FullscreenModal onClose={onClose} className={style.modal}>
      <ModalHeader onClose={onClose}>
        {!taxonomy ? t('Add_New_Asset') : `${t('Modify')} ${taxonomy?.assetId}`}
      </ModalHeader>
      <ModalContent className={style.content}>
        <Loader center show={isFetching} className={style.loader} />
        <div className={isFetching ? style.blur : ''}>
          <div
            className={taxonomy ? style.containerModify : style.container}
          ></div>
        </div>

        <div>
          <h3>Assets</h3>
        </div>
        <div>
          <SelectInputSearch
            isDisabled={_windfarmDisabled}
            error={_windfarmValidation}
            placeHolder={t('select_windfarm')}
            value={_windfarmValue}
            options={_windfarmsOptions}
            onSelectedItemChanged={(e) => {
              handleSelectWindfarm(e);
              _setWindfarmValidation(false);
            }}
          />
          <br />
          <SelectInputSearch
            isDisabled={_turbineDisabled}
            error={_turbineValidation}
            placeHolder={t('select_turbine')}
            value={_turbineValue}
            options={_turbineOptions}
            onSelectedItemChanged={(e) => {
              handleSelectTurbine(e);
              _setTurbineValidation(false);
            }}
          />
        </div>
        <div className={style.conatinerfourColums}>
          <Input
            style={_sidValidation}
            disabled={_autoSIDbool || editing}
            placeholder={t('SID')}
            value={assets ? assets.assetId : _sidValue}
            maxLength={150}
            onChange={(e) => {
              _setSidValue(e);
              _setSidValidation(borderOk);
            }}
          />
          <SelectInputSearch
            isDisabled={editing || assetClassDescriptionOptions.length <= 0}
            error={_assetClassDescriptionValidation}
            placeHolder={t('asset_class_description')}
            value={_assetTypeAcronym}
            options={assetClassDescriptionOptions}
            onSelectedItemChanged={(e) => {
              handleSelectAssetClassDescription(e ? e.value.toString() : '');
            }}
          />
          {newModel || showManufacturerModelInput ? (
            <Input
              disabled={!_assetTypeAcronym}
              style={_modelBoolValidation}
              placeholder={t('manufacturer_model')}
              value={_manufacturerModelValue}
              maxLength={40}
              onChange={(e) => {
                _setManufacturerModelValue(e);
                _setModelBoolValidation(borderOk);
              }}
            />
          ) : (
            <SelectInputSearch
              isDisabled={!_assetTypeAcronym}
              error={_manufacturerModelValidation}
              placeHolder={t('manufacturer_model')}
              value={_manufacturerModelValue}
              options={_manufacturerModelOptions}
              onSelectedItemChanged={(e) => {
                _setManufacturerModelValue(e ? e.value.toString() : '');
                _setManufacturerModelValidation(false);
                handleManufacturerModelToName(e?.value.toString() || '');
                _setManufacturerName('');
              }}
            />
          )}
          {assets ? (
            <div></div>
          ) : (
            <ButtonPrimary
              outline
              onClick={AddAssetToList}
              disabled={assetClassDescriptionOptions.length <= 0}
            >
              {t('add_Asset')}
            </ButtonPrimary>
          )}
          <SelectInputSearch
            isDisabled={!_assetTypeAcronym}
            placeHolder={t('manufacturer_name')}
            options={manufacturerNameOptions}
            value={_manufacturerName}
            onSelectedItemChanged={(e) => {
              _setManufacturerName(e?.value.toString() || '');
            }}
          />
          <Input
            style={_manufacturerSerialNumberValidation}
            placeholder={t('manufacturer_serial_number')}
            value={_manufacturerSerialNumber}
            maxLength={40}
            onChange={(e) => {
              _setManufacturerSerialNumber(e);
              _setManufacturerSerialNumberValidation(borderOk);
            }}
          />
          <Input
            style={_costOfReplacementValidation}
            placeholder={t('cost_of_replacement_euro')}
            value={_costOfReplacement}
            maxLength={31}
            onChange={(e) => {
              _setCostOfReplacement(e);
              _setCostOfReplacementValidation(borderOk);
            }}
          />
          <div className={style.conatinerthreColums}>
            {!editing && (
              <Checkbox
                square
                isChecked={_autoSIDbool}
                onClick={() => _setAutoSIDbool(!_autoSIDbool)}
              >
                {t('auto_SID')}
              </Checkbox>
            )}
            <Checkbox
              square
              isChecked={newModel}
              onClick={() => setNewModel(!newModel)}
            >
              {t('new_model')}
            </Checkbox>
          </div>
          <Input
            style={_purchaseConditionValidation}
            placeholder={t('purchase_condition')}
            value={_purchaseCondition}
            maxLength={40}
            onChange={(e) => {
              _setPurchaseCondition(e);
              _setPurchaseConditionValidation(borderOk);
            }}
          />
          <Input
            style={_equipAttributesEffileValidation}
            placeholder={t('equip_attributes_efile_attachment')}
            value={_equipAttributesEffile}
            maxLength={40}
            onChange={(e) => {
              _setEquipAttributesEffile(e);
              _setEquipAttributesEffileValidation(borderOk);
            }}
          />
          <Input
            style={instaledDateValidation}
            className={style.correctInput}
            value={_intaledDate}
            type={'date'}
            placeholder={'Commisioning Date'}
            onChange={(e) => {
              _setInstaledDateValidation(borderOk);
              _setInstaledDate(e);
            }}
          />
        </div>
        <DataTable
          columns={assets ? columnsBearings : columnsAsset}
          data={assets ? _bearingsList : _assetsDataList}
          className={style.table}
          pagination={5}
        />

        <div className={style.navigation}>
          <ButtonPrimary onClick={onClose} outline>
            {t('Cancel')}
          </ButtonPrimary>
          <ButtonPrimary
            outline
            onClick={assets ? sendDataModify : sendData}
            disabled={disableSaveButton}
          >
            {t('Save')}
          </ButtonPrimary>
        </div>
      </ModalContent>
    </FullscreenModal>
  );
};
